import { L10nLoader } from 'angular-l10n';

export function defaultL10nLoader(l10nLoader: L10nLoader): Function {
	return () => l10nLoader.init();
}
